import { render, staticRenderFns } from "./CustomImage.vue?vue&type=template&id=c9888cfc&scoped=true&"
import script from "./CustomImage.vue?vue&type=script&lang=ts&"
export * from "./CustomImage.vue?vue&type=script&lang=ts&"
import style0 from "./CustomImage.vue?vue&type=style&index=0&id=c9888cfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9888cfc",
  null
  
)

export default component.exports